import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PropertyType } from '../../../../shared/models/property-type';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-caracteristiques-edit-mode',
  templateUrl: './caracteristiques-edit-mode.component.html',
  styleUrls: ['./caracteristiques-edit-mode.component.scss'],
})
export class CaracteristiquesEditModeComponent implements OnChanges {
  @Input() characteristics!: Report.Characteristics;
  @Input() propertyType!: PropertyType;

  @Output() characteristicsChanged = new EventEmitter<Report.Characteristics>();

  private characteristicsClient!: Report.Characteristics;

  ngOnChanges(changes: SimpleChanges): void {
    const currentCharacteristicsClient =
      changes['characteristics'].currentValue;
    if (currentCharacteristicsClient) {
      this.characteristicsClient = currentCharacteristicsClient;
    }
  }

  onConstructionYearChanged(constructionYear: number): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      constructionYear,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onBienAgricoleChanged(
    bienAgricole: Report.Characteristics.BienAgricole,
  ): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      bienAgricole,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onAppartementChanged(appartement: Report.Characteristics.Appartement): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      appartement,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onGarageChanged(garage: Report.Characteristics.Garage): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      garage,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onImmeubleChanged(immeuble: Report.Characteristics.Immeuble): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      immeuble,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onMaisonChanged(maison: Report.Characteristics.Maison): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      maison,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onTerrainChanged(terrain: Report.Characteristics.Terrain): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      terrain,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onBienViticoleChanged(
    bienViticole: Report.Characteristics.BienViticole,
  ): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      bienViticole,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }

  onLocalActiviteChanged(
    localActivite: Report.Characteristics.LocalActivite,
  ): void {
    this.characteristicsClient = {
      ...this.characteristicsClient,
      localActivite,
    };

    this.characteristicsChanged.emit(this.characteristicsClient);
  }
}
